import React, { useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";

import images from '../../../helpers/images';
import appConfig from '../../../config/env';
import helpers from '../../../helpers/helpers';
import { httpRequest } from '../../../helpers/httpService';
import store from '../../../helpers/store';
import Swal from 'sweetalert2';
import InputText from '../../elements/InputText';
import DropDownSelection from '../../elements/DropDownSelection';
import Loader from '../../parts/Loader';
import Checkbox from '../../elements/Checkbox';
import Paginations from '../../parts/Paginations';
 
function TransactionPage (){
    const api_url = appConfig.apiUrl;
    let { event_id } = useParams();
    const [event_data, setEvent] = useState([]);
    const [category_list, setCategories] = useState([]);
    const [type_list, setTypes] = useState([]);
    const [transaction_list, setTransactions] = useState([]);
    const [loading, setLoading] = useState(1);
    const [res_data, setResData] = useState([]);


    const [selected_status, setStatus] = useState('');
    const [selected_transactions, setSelectedTransactons] = useState([]);
    const [all_selected, setAllSelected] = useState(0);

    // Search
    const [search_key, setSearchKey] = useState('');
    const [input_type, setInputType] = useState('text');
    const [search_filter, setFilter] = useState('title');
    const [tab, changeTab] = useState('events-list');

    const per_page = 5; //Default per page

    useEffect(() => {
        getEvent()
    }, []);

    useEffect(() => {
        if(search_filter == 'date'){
            setInputType('date')
            return;
        }
        
        setSearchKey('')
        setInputType('search')
        isAllSelected()
    }, [search_filter]);

    useEffect(() => {
        isAllSelected()
    }, [transaction_list]);

    useEffect(() => {
        isAllSelected()
        const total = selected_transactions.length

        //Reset Status
        if(!total){
            setStatus('')
        }
    }, [selected_transactions]);

    function isAllSelected(){
        let selected_references = [...selected_transactions];
        const total = Object.keys(transaction_list).length;
        let counter = 0;

        transaction_list.forEach(data => {
            const is_existed = selected_references.includes(data.reference_no);

            if(is_existed){
                counter++;
            }
        });

        if(total>1){
            if(total === counter){
                setAllSelected(1)
            }else{
                setAllSelected(0)
            }
        }
    }

    function getEvent() {
      const url = api_url + '/admin/events/'+event_id;
      setLoading(1)

      httpRequest(url, "GET", {}, true)
          .then((res) => {
              setEvent(res)
              getTransactions()
              //setLoading(0)
          })
          .catch((err) => {
              setLoading(0)
                
              //Unauthorize
              if(err.status_code === 401){
                  window.location.href = "/";
              }

              Swal.fire({
                  title: "Error!",
                  text: err.message,
                  icon: "error",
                  confirmButtonText: "OK",
              });
          }); 
  }

    function getTransactions() {
        const params = '?per_page='+per_page
        const url = api_url + '/admin/events/'+event_id+'/transations' + params;
        setLoading(1)

        sendRequest(url)
    }
    

    function sendRequest(url){
      httpRequest(url, "GET", {}, true)
          .then((res) => {
              setTransactions(res.data);
              setResData(res);
              setLoading(0)
          })
          .catch((err) => {
              setLoading(0)

              Swal.fire({
                  title: "Error!",
                  text: err.message,
                  icon: "error",
                  confirmButtonText: "OK",
              });
          }); 
    }

    
    function changePage(page) {
        // let params = '?per_page='+per_page+'&page='+page

        // if(search_key!==''){
        //     params += '&' + search_filter+'='+search_key
        // }
        let params = '?per_page='+per_page+'&search'+'='+search_key+'&page='+page

        const url = api_url + '/admin/events/'+event_id+'/transations'+params;

        setLoading(1)
        sendRequest(url)
    }

    function handleSearch(){
        let params = '?per_page='+per_page+'&search'+'='+search_key

        const url = api_url + '/admin/events/'+event_id+'/transations' + params;

        setLoading(1)
        sendRequest(url)
    }

    function handleUpdate(){
        const total = selected_transactions.length;
        const url = api_url + '/admin/transactions/bulk';

        if(!total){
            Swal.fire({
                title: "Error!",
                text: 'Please select at least one (1) transaction.',
                icon: "error",
            });
            return;
        }else if(!selected_status){
            Swal.fire({
                title: "Error!",
                text: 'Please select status.',
                icon: "error",
            });
            return;
        }

        setLoading(1)
        httpRequest(url, "POST", {
            postdata: 
            {
              status: selected_status,
              references: selected_transactions,
            },
        }, true)
        .then((res) => {
            Swal.fire({
                title: 'Success!',
                text: res.message,
                icon: 'success',
                confirmButtonText: 'OK'
            });

            setStatus('')
            setSelectedTransactons([])
            getEvent()
        })
        .catch((err) => {
            setLoading(0);
                
            //Unauthorize
            if(err.status_code === 401){
                window.location.href = "/";
            }
  
            if(err.data){
                //setErrors( err.data );
                err.message = "Please check your entry";
                
  
                // if(err.data.captcha){
                //     err.message = err.data.captcha[0];
                // }
            }else{
              //setErrors([])
            }
  
            Swal.fire({
                title: 'Error!',
                text: err.message,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        });
    }

    function clearSearch(){
        setSearchKey('')
        getEvent()
    }

    function table_items(transaction_list){
        let table_items = [];

        if (Object.keys(transaction_list).length > 0) {
          table_items = Object.entries(transaction_list).map(([key, data]) => {
                return (<tr key={key}>
                              <td>
                                <div className="form-check">
                                    <Checkbox
                                        id={data.reference_no}
                                        name="selected_transactions"
                                        value={data.reference_no}
                                        labelClass="form-check-label"
                                        tagClass="form-check-input radio-box"
                                        onChange={singleCheck}
                                        checked = {selected_transactions.includes(data.reference_no)}
                                    />
                                </div>
                              </td>
                              <td>{data.reference_no}</td>
                              <td>{data.first_name + ' ' + data.last_name}</td>
                              <td>{data.email}</td>
                              <td>{data.user_id ? 'Yes': ''}</td>
                              <td>{data.payment_method}</td>
                              <td>{data.payment_type}</td>
                              <td>PHP {helpers.formatNumber(data.donated_amount)}</td>
                              <td>PHP {helpers.formatNumber(data.total_amount)}</td>
                              <td>{data.date}</td>
                              <td>{data.payment_status}</td>
                        </tr>
                        )
          })
        }else{
          table_items = <tr>
                  <td colSpan="10" className='text-center'>No available data</td>
            </tr>
        }

        return table_items;
    }

    function singleCheck(e){
        let { value, name } = e.target;
        let selected_references = [...selected_transactions];

        const is_existed = selected_references.includes(value);
        
        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                if(!is_existed){
                    selected_references.push(value)
                }
            } else {
                selected_references = selected_references.filter(item => item !== value)
            }
        }

        setSelectedTransactons(selected_references)
    }

    function selectAll(e){
        let selected_references = [...selected_transactions];

        if (e.target.type === "checkbox") {
          if (e.target.checked) {
              transaction_list.forEach(data => {
                  const is_existed = selected_references.includes(data.reference_no);
                  if(!is_existed){
                    selected_references.push(data.reference_no)
                  }
              });
          } else {
              transaction_list.forEach(data => {
                  selected_references = selected_references.filter(item => item !== data.reference_no)
              });
          }
        }
        
      
        setSelectedTransactons(selected_references)
    }

    function total_selected(){
        const total = selected_transactions.length

        return total ? '(' + total + ' selected)' : '';
    }

    
    const displaySearchField = () =>  {
        if(search_filter === 'category'){
            return <DropDownSelection
                        tagClass="form-select border-end-0 border-0 border-bottom"
                        name={'search_filter'} 
                        placeholder='Select Category'
                        value={search_key}  
                        onChange={e => setSearchKey(e.target.value)}
                        optionList={category_list}
                        optionProps ={{value:'id', label:'category_name'}}
                        origin="category"
                    />
        }
        else if(search_filter === 'type'){
            return <DropDownSelection
                        tagClass="form-select border-end-0 border-0 border-bottom"
                        name={'search_filter'} 
                        placeholder='Select Type'
                        value={search_key}  
                        onChange={e => setSearchKey(e.target.value)}
                        optionList={type_list}
                        optionProps ={{'value':'id', 'label':'type_name'}}
                        origin="type"
                    />
        }
        else if(search_filter === 'status'){
            return <DropDownSelection
                        tagClass="form-select border-end-0 border-0 border-bottom"
                        name={'search_filter'} 
                        placeholder='Select Status'
                        value={search_key}  
                        onChange={e => setSearchKey(e.target.value)}
                        optionList={store.event_status}
                        optionProps ={{value:'id', label:'name'}}
                        origin="status"
                    />
        }
        else{
            return <InputText
                        id="search_key" 
                        name="search_key" 
                        value={search_key}   
                        tagClass="form-control border-end-0 border-0 border-bottom"
                        onChange={e => setSearchKey(e.target.value)}
                        placeholder="Search for reference #, first name, last name or email."
                        type={input_type}
                    />
        }
    };

    return (
        <section className="faith">
        <div className="container">
        <div className="parent">
          <div className="container py-4" style={{position: 'relative'}}>
            
            <Loader isLoading={loading}/>

            <h3 className='mb-3'>
                { event_data.title ? event_data.title : 'Loading...'}
            </h3>
            <div className="card filter-dashboard p-4">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h6 className="looking">What are you looking for?</h6>
                    <div className="row mt-2">
                      <div className="input-group">
                        {displaySearchField()}

                        <span className="input-group-append">
                          <button type="button" className="cancelbtn" onClick={handleSearch}>Search</button>
                          <button type="button" className="cancelbtn ms-2" onClick={clearSearch}>Clear</button>
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-5">
                    <h6 className="looking">Filter</h6>
                    <div className="row mt-2">
                      <div className="input-group mt-4">
                        <DropDownSelection
                            tagClass="form-select border-end-0 border-0 border-bottom"
                            name={'search_filter'} 
                            placeholder='Select Filters'
                            value={search_filter}  
                            onChange={e => setFilter(e.target.value)}
                            optionList={store.admin_search_filters}
                            optionProps ={{value:'id', label:'name'}}
                            origin="filters"
                        />

                        <span className="input-group-append">
                          <button className="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border-0 ms-n5" type="button">
                            <i className="fa fa-filter" />
                          </button>
                        </span>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Login navigation */}
            <div className="container card filter-dashboard mx-0 px-0">
              <nav id="events-tab" className="navigation-login d-flex justify-content-between">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button className="nav-link active list-events" id="nav-transaction-tab" data-bs-toggle="tab" data-bs-target="#nav-transaction" type="button" role="tab" aria-controls="nav-all-event" aria-selected="true" onClick={(e)=>changeTab('all')}>Transactions</button>
                </div>
                <div className="d-flex btns">
                  <Link className="btn btn-link" to="/admin/"><img src={images.arrowIcon} /> Back to Dashboard</Link>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                
                <div className="tab-pane fade show active px-4" id="nav-transaction" role="tabpanel" aria-labelledby="nav-transaction-tab">
                  <div className="row mt-3 border-bottom pb-3 d-flex justify-content-between">
                      <div className="col-lg-4">
                          <h4 className="faith-login-title">List of Transactions <span style={{fontSize: '.8rem', fontWeight: 'normal'}}>{total_selected()}</span></h4>
                      </div>
                      <div className="col-lg-4">
                            <div className='input-group'>
                                <DropDownSelection
                                      tagClass="form-select border-end-0 border-0 border-bottom"
                                      name={'selected_status'} 
                                      placeholder='Select Status'
                                      value={selected_status}  
                                      onChange={e => setStatus(e.target.value)}
                                      optionList={store.payment_status}
                                      optionProps ={{value:'id', label:'name'}}
                                      origin="category"
                                />
                                <button type="button" className="cancelbtn" onClick={(e) => handleUpdate()}>UPDATE</button>
                            </div>
                      </div>
                  </div>
                

                  <div className="table-responsive">
                    <table className="table table-responsive table-hover">
                      <thead>
                        <tr>
                          <th>
                            <Checkbox
                                id="select-all"
                                name="select_all"
                                value="select-all"
                                labelClass="form-check-label"
                                tagClass="form-check-input radio-box"
                                onChange={selectAll}
                                checked = {all_selected}
                            />
                          </th>
                          <th scope="col">REFERENCE NO.</th>
                          <th scope="col">REGISTRANT</th>
                          <th scope="col">EMAIL</th>
                          <th scope="col">HAS&nbsp;ACCOUNT</th>
                          <th scope="col">METHOD</th>
                          <th scope="col">TYPE</th>
                          <th scope="col">DONATION</th>
                          <th scope="col">TOTAL AMOUNT</th>
                          <th scope="col">DATE</th>
                          <th scope="col">STATUS</th>
                          {/* <th scope="col">ACTION</th> */}
                        </tr>
                      </thead>
                      <tbody>
                            {table_items(transaction_list)}
                      </tbody>
                    </table>

                    <Paginations
                        current_page={res_data.current_page}
                        total_page={res_data.total}
                        per_page={res_data.per_page}
                        changePage={changePage}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* End Login navigation  */}
          </div>
        </div>
        </div>
        </section>
    )
}
 
export default TransactionPage;